// Packages
import ListItem from 'modules/Notes/components/ListItem';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const NoteList = ({ isLoading, items, onChange, parent, parentId }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='NoteList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No notes to show here</h3>
		)
	}


	// Data State
	return (
		<div className='NoteList'>

			{items.map((item, index) => {

				return (
					<div key={index}>
						<ListItem 
							{...item} 
							isLoading={false}
							onChange={() => {onChange()}}
							parent={parent}
							parentId={parentId}
						/>
					</div>
				)
				
			})}
	
		</div>
	)
}

NoteList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

NoteList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	parent: '',
    parentId: ''
}

export default NoteList;